import React from 'react';
import { T, fontBody, fontMono, selectStyle } from '../../tokens';
import Field from '../Field';

const MATCH_RULE_OPTIONS = [
  { value: 'contains_any', label: 'Contains any keyword' },
  { value: 'contains_all', label: 'Contains all keywords' },
];

function KeywordChip({ text, onRemove }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      fontFamily: fontMono, fontSize: 11.5, fontWeight: 500,
      background: T.ink, color: '#fff', padding: '3px 9px', borderRadius: 6,
    }}
    >
      {text}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          style={{ border: 'none', background: 'transparent', color: '#fff', cursor: 'pointer', padding: 0, lineHeight: 1 }}
        >
          ×
        </button>
      )}
    </span>
  );
}

export default function KeywordNodeEditor({
  keywords,
  matchRule,
  onKeywordsChange,
  onMatchRuleChange,
  error,
}) {
  const tags = Array.isArray(keywords) ? keywords : [];

  const addKeyword = (raw) => {
    const next = String(raw || '').split(',').map((k) => k.trim()).filter(Boolean);
    if (!next.length) return;
    onKeywordsChange([...new Set([...tags, ...next])]);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Field label="Match rule">
        <select
          style={selectStyle}
          value={matchRule || 'contains_any'}
          onChange={(e) => onMatchRuleChange(e.target.value)}
        >
          {MATCH_RULE_OPTIONS.map((r) => (
            <option key={r.value} value={r.value}>{r.label}</option>
          ))}
        </select>
      </Field>

      <Field label="Keywords">
        <div style={{
          display: 'flex', gap: 6, flexWrap: 'wrap', padding: 8,
          border: `1px solid ${error ? '#DC2626' : T.line}`, borderRadius: 8, minHeight: 40,
        }}
        >
          {tags.map((k) => (
            <KeywordChip
              key={k}
              text={k}
              onRemove={() => onKeywordsChange(tags.filter((t) => t !== k))}
            />
          ))}
          <input
            placeholder={tags.length ? 'Add more…' : 'PMAY, price, brochure'}
            style={{
              flex: 1, minWidth: 120, border: 'none', outline: 'none',
              fontFamily: fontBody, fontSize: 13, color: T.ink, background: 'transparent',
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ',') {
                e.preventDefault();
                addKeyword(e.target.value);
                e.target.value = '';
              }
            }}
            onBlur={(e) => {
              if (e.target.value.trim()) {
                addKeyword(e.target.value);
                e.target.value = '';
              }
            }}
          />
        </div>
        {error && <div style={{ fontSize: 11, color: '#DC2626', marginTop: 4 }}>{error}</div>}
      </Field>
    </div>
  );
}
